import React, { Component, Fragment, useRef } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Lightbox from 'lightbox-react'
import { Field, Form } from 'react-final-form'
import { Wrapper } from '../../Container/Container.style'
import { SecondaryButton, ButtonArrow } from '../../../shared/Buttons/Buttons.styles'
import { SignUpBannerImage, StyledPopup, StyledSubmit } from './SignUpBanner.style'
import ArrowRight from '../Icons/ArrowRight'
import { Checkbox, ErrorMessage, FormWrapper, Input, Label } from '../../../styles/form'
import { CONFIRM_VIA_EMAIL_LABEL, EMAIL_FIELD_LABEL, EMAIL_FIELD_PLACEHOLDER, KANJI_NAME_FIELD_LABEL } from '../../../locales'
import { composeValidators, isEmailValid, isKanji, required } from '../../../utils/validators'

const Popup = (props) => {
  const form = useRef(null)
  const handleSubmitFunc = (values) => {
    form.current.submit()
  }

  const { title } = props

  return (
    <StyledPopup>
      <h4>{title}</h4>
      <Form
        onSubmit={handleSubmitFunc}
        render={({ handleSubmit }) => (
          <FormWrapper
            onSubmit={handleSubmit}
            data-netlify="true"
            data-netlify-honeypot="bot"
            ref={form}
            method="post"
            action="https://mqa.us11.list-manage.com/subscribe/post?u=79342aa8e374e32ed2c802400&id=a4039ad0bf&c=?"
          >
            <Field
              name="EMAIL"
              validate={composeValidators(required, isEmailValid)}
            >
              {({ input, meta }) => (
                <div>
                  <Label htmlFor={EMAIL_FIELD_LABEL}>{EMAIL_FIELD_LABEL}</Label>
                  <Input
                    {...input}
                    type="email"
                    aria-label={EMAIL_FIELD_PLACEHOLDER}
                    placeholder={EMAIL_FIELD_PLACEHOLDER}
                  />
                  {meta.error && meta.touched && (
                    <ErrorMessage>{meta.error}</ErrorMessage>
                  )}
                </div>
              )}
            </Field>

            <Field
              name="FNAME"
              validate={composeValidators(required, isKanji)}
            >
              {({ input, meta }) => (
                <div>
                  <Label htmlFor={KANJI_NAME_FIELD_LABEL}>
                    {KANJI_NAME_FIELD_LABEL}
                  </Label>
                  <Input
                    {...input}
                    type="text"
                    placeholder={KANJI_NAME_FIELD_LABEL}
                    maxLength="40"
                    aria-label={KANJI_NAME_FIELD_LABEL}
                  />
                  {meta.error && meta.touched && (
                    <ErrorMessage>{meta.error}</ErrorMessage>
                  )}
                </div>
              )}
            </Field>

            <Field name={CONFIRM_VIA_EMAIL_LABEL} validate={required}>
              {({ input, meta }) => (
                <Checkbox>
                  <Input
                    {...input}
                    type="checkbox"
                    id={CONFIRM_VIA_EMAIL_LABEL}
                  />
                  <Label htmlFor={CONFIRM_VIA_EMAIL_LABEL}>
                    {CONFIRM_VIA_EMAIL_LABEL}
                  </Label>
                  {meta.error && meta.touched && (
                    <ErrorMessage>{meta.error}</ErrorMessage>
                  )}
                </Checkbox>
              )}
            </Field>

            <div>
          ご登録された情報は弊社の
              {' '}
              <a
                href="/legal"
                rel="noopener noreferrer"
                target="_blank"
              >
プライバシーポリシー
              </a>
              {' '}
に基づき、運用・管理します。詳しくはプライバシーポリシーをご覧ください。
            </div>
            <div
              style={{
                'position': 'absolute',
                left: '-5000px',
              }}
              aria-hidden="true"
            >
              <input type="text" name="b_79342aa8e374e32ed2c802400_a4039ad0bf" tabIndex="-1" defaultValue="" />
            </div>
            <StyledSubmit>
              <button type="submit" name="subscribe" defaultValue="">
                登録する
                <ButtonArrow viewBox="0 0 12 21">
                  <ArrowRight />
                </ButtonArrow>
              </button>
            </StyledSubmit>
          </FormWrapper>
        )}
      />
    </StyledPopup>
  )
}

Popup.propTypes = {
  title: PropTypes.string.isRequired,
}

export default class SignUpBanner extends Component {
  state = {
    isOpen: false,
  }

  render() {
    const {
      title,
      description,
      ctaLabel,
      backgroundImage,
    } = this.props

    const { isOpen } = this.state

    return (
      <Fragment>
        <SignUpBannerImage className="wow fadeInLeft" data-wow-duration="0.8s" data-wow-offset="80">
          <div
            className="wrapper"
            style={{
              backgroundImage: `url('${backgroundImage ? backgroundImage.file.url : ''}')`,
            }}
          >
            <Wrapper>
              <div>
                <h4>{title}</h4>
                {description && (
                  <div
                    className="productDescription"
                    dangerouslySetInnerHTML={{
                      __html: description.childMarkdownRemark.html,
                    }}
                  />
                )}
              </div>

              <SecondaryButton onClick={() => {
                this.setState({
                  isOpen: true,
                })
              }}
              >
                <button type="button">
                  {ctaLabel}
                  <ButtonArrow viewBox="0 0 12 21"><ArrowRight /></ButtonArrow>
                </button>
              </SecondaryButton>
            </Wrapper>
          </div>
        </SignUpBannerImage>
        {isOpen && (
          <Lightbox
            mainSrc={<Popup title={title} />}
            enableZoom={false}
            clickOutsideToClose
            onCloseRequest={() =>
              this.setState({
                isOpen: false,
              })
            }
          />
        )}
      </Fragment>
    )
  }
}

export const SignUpBannerFragment = graphql`
  fragment SignUpBannerFragment on ContentfulSignUpBanner {
    title
    description {
      childMarkdownRemark {
        html
      }
    }
    ctaLabel
    backgroundImage {
      file {
        url
      }
    }
  }
`

SignUpBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string.isRequired,
    }),
  }),
  ctaLabel: PropTypes.string.isRequired,
  backgroundImage: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
}

SignUpBanner.defaultProps = {
  description: null,
  backgroundImage: null,
}
